import { useContext } from "react"
import { Context } from "../../../../.."
import formatDateTimeServer from "../../../../../Utils/formatDateTimeServer";
import formatCurrency from "../../../../../Utils/formatCurrency";

function HistoryComponent({data}){
    const {store} = useContext(Context);
    return (
        <tr>
            <td>{data.auction_id}</td>
            <td>{formatCurrency(data.total_bet_user,"cost")}</td>
            <td>{store.dataLang[data.status+"_auction"]}</td>
            <td>{data.percent_profit>0?data.percent_profit+"%":"-"}</td>
            <td>{data.profit_amount>0?formatCurrency(data.profit_amount,"cost")	:"-"}</td>
            <td>{formatDateTimeServer(new Date(data.date))}</td>


        </tr>
    )
}
export default HistoryComponent